<template>
    <div class="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 px-4 bg-gray-900">
        <InertiaHead :title="title ? `${title} - ${$page.props.appName}` : $page.component + ' - ' + $page.props.appName">
            <meta v-if="metaDescription" head-key="description" name="description" :content="metaDescription" />
            <slot name="head"/>
        </InertiaHead>
        <div>
            <InertiaLink href="/">
                <BreezeApplicationLogo
                    type="white"
                    class="w-auto h-24 fill-current text-gray-100"
                />
            </InertiaLink>
        </div>
        <Flash
            v-if="$page.props.flash.error || $page.props.flash.success"

            @leave="ev => {
                $page.props.flash.error = ev;
                $page.props.flash.success = ev;
            }"
        />
        <div class="w-full sm:w-9/12 sm:max-w-3xl mx-6 mt-6 px-6 py-4 bg-white shadow-md overflow-hidden rounded-md">
            <slot />
        </div>
        <div class="w-full sm:w-9/12 sm:max-w-3xl mx-6 px-6 py-4 rounded-md text-right">
            <InertiaLink
                v-if="route().current('register')"
                :href="route('login')"
                class="text-sm text-gray-200 font-bold bg-red-700 rounded-md px-3 py-2 underline">
                {{__('Log in')}}
            </InertiaLink>
        </div>
        <Cookies
            v-if="showCookie == true"
            @update="ev => showCookie = ev"
        />
    </div>
</template>

<script>
    import BreezeApplicationLogo from 'COMP/ApplicationLogo';
    import Flash from 'COMP/Flash';
    import Cookies from 'UI/Cookies';
    import { ref } from '@vue/reactivity';
    import { usePage } from '@inertiajs/inertia-vue3';

    export default {
        props: ['title', 'metaDescription'],
        components: {
            BreezeApplicationLogo, Flash, Cookies
        },

        setup(props) {

            const showCookie = ref( checkCookie(usePage().props.value.appName + '_cookie_consent') != 'on' ? true : false);
            function checkCookie(name) {
                var nameEQ = name + "=";
                var ca = document.cookie.split(';');
                for(var i=0;i < ca.length;i++) {
                    var c = ca[i];
                    while (c.charAt(0)==' ') c = c.substring(1,c.length);
                    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
                }
                return null;
            }

            return {
                showCookie,
                checkCookie
            }
        }
    }
</script>
